import React from 'react';
import moment from "moment";

import { Grid } from '@material-ui/core';

import NonFieldErrors from '../../../../../components/AssetModal/components/NonFieldErrors';
import InputFormElement
  , {CurrencyNumberFormat} from "../../../../RiskProfiling/components/StepContent/components/formElement/InputFormElement";
import CalendarFormElement
  from "../../../../RiskProfiling/components/StepContent/components/formElement/CalendarFormElement";
import {newDesignInputCustomClasses} from "../../../../RiskProfiling/constants";
import {PercentageNumberFormat} from "../../../../RiskProfiling/components/StepContent/components/formElement/InputFormElement/InputFormElement";
import {END_DATE_SHOULD_BE_AFTER_START} from "../../../../Trades/constants";
import {newDesignInputCustomClassesViewOnly} from "../../../constants";
import {getCalculationDisabledReason} from "../../utils";
import SelectFormElementV2
  from "../../../../RiskProfiling/components/StepContent/components/formElement/SelectFormElementV2";
import {DEPT_INSURANCE_OPTIONS, LOAN_AUTO_CALC_INFO} from "../../constants";
import AutoCalculateToggle from "../AutoCalculateToggle";
import useLoanModel from "../hooks/useLoanModel";

const START_DATE_LABEL = 'Laufzeit von';
const FIXED_INTEREST_DATE_LABEL = 'Zinsbindungsdatum';
const INTEREST_RATE_LABEL = 'Zinssatz';
const PAYMENT_RATE_LABEL = 'Tilgungssatz p.a.';
const ORIGINAL_VALUE_LABEL = 'Urspr. Höhe d. Verbindl.';

const AUTO_CALC_DISABLED_INFO = getCalculationDisabledReason([
  ORIGINAL_VALUE_LABEL, START_DATE_LABEL, FIXED_INTEREST_DATE_LABEL, INTEREST_RATE_LABEL, PAYMENT_RATE_LABEL
]);


const LiabilityOtherForm = (props) => {

  const {
    handleFormChange,
    defaults,
    errors,
    viewOnly
  } = props;

  const [model, handleModelChange, isAutoCalcAvailable, monthlyAnnuity, monthlyAmount, value] = useLoanModel(
    defaults, handleFormChange
  );

  const inputClasses = viewOnly ? newDesignInputCustomClassesViewOnly : newDesignInputCustomClasses;

  return (
    <>
      {!viewOnly && (
        <Grid item xs={12}>
          <InputFormElement
            label="Kategorie"
            value={model.sub_category}
            error={errors.sub_category}
            onChange={handleModelChange('sub_category')}
            dataId={'category-input'}
            custom_classes={inputClasses}
            required
            disabled={viewOnly}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={4}>
        <InputFormElement
          label={'Name / Bezeichnung'}
          required={!viewOnly}
          value={model.name}
          error={errors.name}
          onChange={handleModelChange('name')}
          dataId={'name-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFormElement
          label={'Gesellschaft'}
          value={model.company}
          error={errors.company}
          onChange={handleModelChange('company')}
          dataId={'company_input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFormElement
          label={ORIGINAL_VALUE_LABEL}
          inputComponent={CurrencyNumberFormat}
          inputProps={{inputProps: {allowNegative: false}}}
          value={model.original_value}
          error={errors.original_value}
          onChange={handleModelChange('original_value')}
          dataId={'original_value-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Grid container spacing={1}>
          <Grid item xs>
            <CalendarFormElement
              label={START_DATE_LABEL}
              value={model.start_date}
              error={errors.start_date}
              onChange={handleModelChange('start_date')}
              dataId={'start_date-input'}
              disabled={viewOnly}
              custom_classes={inputClasses}
            />
          </Grid>
          <Grid item xs={'auto'} style={{marginTop: viewOnly ? 26 : 32, padding: 0}}>–</Grid>
          <Grid item xs>
            <CalendarFormElement
              label="Laufzeit bis"
              value={model.end_date}
              error={errors.end_date}
              minDate={model.start_date || undefined}
              minError={END_DATE_SHOULD_BE_AFTER_START}
              onChange={handleModelChange('end_date')}
              dataId={'end_date-input'}
              disabled={viewOnly}
              custom_classes={inputClasses}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={6}>
        <CalendarFormElement
          label={FIXED_INTEREST_DATE_LABEL}
          value={model.fixed_interest_date}
          error={errors.fixed_interest_date}
          minDate={model.start_date || undefined}
          minError={END_DATE_SHOULD_BE_AFTER_START}
          onChange={handleModelChange('fixed_interest_date')}
          dataId={'fixed_interest_date-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <InputFormElement
          label={INTEREST_RATE_LABEL}
          inputComponent={PercentageNumberFormat}
          inputProps={{inputProps: {allowNegative: false, isAllowed: (values) => {
            const {floatValue} = values;
            return !floatValue || floatValue <= 100;
          }}}}
          value={model.interest_rate}
          error={errors.interest_rate}
          onChange={handleModelChange('interest_rate')}
          dataId={'interest_rate-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFormElement
          label={PAYMENT_RATE_LABEL}
          inputComponent={PercentageNumberFormat}
          inputProps={{inputProps: {allowNegative: false, isAllowed: (values) => {
            const {floatValue} = values;
            return !floatValue || floatValue <= 100;
          }}}}
          value={model.payment_rate}
          error={errors.payment_rate}
          onChange={handleModelChange('payment_rate')}
          dataId={'payment_rate-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Grid container spacing={1}>
          {/*FIXME: DISABLED FOR NOW as part of BCA-10671*/}
          {/*{!viewOnly && (*/}
          {/*  <Grid item xs={'auto'}>*/}
          {/*    <AutoCalculateToggle*/}
          {/*      value={model.is_auto_calculation}*/}
          {/*      handleValueChanged={handleModelChange('is_auto_calculation')}*/}
          {/*      disabled={!isAutoCalcAvailable}*/}
          {/*      disableReason={!isAutoCalcAvailable && AUTO_CALC_DISABLED_INFO}*/}
          {/*      info={isAutoCalcAvailable && LOAN_AUTO_CALC_INFO}*/}
          {/*    />*/}
          {/*  </Grid>*/}
          {/*)}*/}
          <Grid item xs>
            <InputFormElement
              label="Monatliche Tilgungssumme"
              inputComponent={CurrencyNumberFormat}
              inputProps={{inputProps: {allowNegative: false}}}
              value={monthlyAmount}
              error={errors.monthly_amount}
              onChange={handleModelChange('monthly_amount')}
              dataId={'monthly_amount-input'}
              disabled={viewOnly || model.is_auto_calculation}
              custom_classes={inputClasses}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputFormElement
          label="Monatliche Annuität"
          inputComponent={CurrencyNumberFormat}
          inputProps={{inputProps: {allowNegative: false}}}
          value={monthlyAnnuity}
          error={errors.monthly_annuity}
          onChange={handleModelChange('monthly_annuity')}
          dataId={'monthly_annuity-input'}
          disabled={viewOnly || model.is_auto_calculation}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputFormElement
          label="Höhe d. Verbindlichkeit"
          inputComponent={CurrencyNumberFormat}
          inputProps={{inputProps: {allowNegative: false}}}
          value={value}
          error={errors.value}
          onChange={handleModelChange('value')}
          dataId={'value-input'}
          required={!viewOnly}
          disabled={viewOnly || model.is_auto_calculation}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <SelectFormElementV2
          label="Restschuldversicherung"
          value={model.debt_insurance}
          options={DEPT_INSURANCE_OPTIONS}
          required={!viewOnly}
          error={errors.debt_insurance}
          onChange={handleModelChange('debt_insurance')}
          dataId={'debt_insurance-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
          addEmptyOption
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <InputFormElement
          label="Darlehensschlussrate"
          inputComponent={CurrencyNumberFormat}
          inputProps={{inputProps: {allowNegative: false}}}
          value={model.final_amount}
          error={errors.final_amount}
          onChange={handleModelChange('final_amount')}
          dataId={'final_amount-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <CalendarFormElement
          label="Stand vom"
          value={model.updated || moment()}
          dataId={'updated-input'}
          disabled
          required={!viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      {!!errors['non_field_errors'] && <NonFieldErrors errors={errors['non_field_errors']}/>}
    </>
  )
};

LiabilityOtherForm.defaultProps = {
  defaults: {},
  errors: {}
};

export default LiabilityOtherForm;